import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Section, Container, Grid, Col, SectionHeader } from '../../common';

const ImageGallery = ({ sanity, page, section }) => {
  const { gallery, colors } = sanity;
  const { images, displayAllImages } = section;

  // Map over the galleryData to match the format expected by gatsby-image-gallery
  const allImages = gallery?.map(({ image, _rawCaption, title }) => ({
    thumb: image?.asset?.gatsbyImageData,
    full: image?.asset?.gatsbyImageData,
    thumbAlt: image?.alt,
    title,
    caption: _rawCaption,
  }));

  const selectedImages = images?.map(({ image, _rawCaption, title }) => ({
    thumb: image?.asset?.gatsbyImageData,
    full: image?.asset?.gatsbyImageData,
    thumbAlt: image?.alt,
    title,
    caption: _rawCaption,
  }));

  const displayedImages = displayAllImages
    ? allImages?.sort((a, b) => a.title.localeCompare(b.title))
    : selectedImages;

  return (
    <Section
      idName="image-gallery"
      bgColor={colors?.neutral?.lighter}
      h2Color={colors?.neutral?.darker}
    >
      <Container
        padding="none"
        classes="max-w-md px-4 text-center sm:max-w-3xl lg:max-w-7xl"
        inViewConfigMargin="1500px"
      >
        <SectionHeader
          sanity={sanity}
          tagline={section?.header?.tagline}
          headline={section?.header?.headline}
          description={section?.header?._rawDescription}
        />
        <div className="columns-1 md:columns-3 lg:columns-3">
          {displayedImages?.map((image, index) => (
            <Col inViewConfigMargin="500px 0px" key={index} classes="mb-4">
              <div>
                <GatsbyImage
                  image={image.full}
                  alt={image.thumbAlt}
                  className="rounded-xl shadow-xl"
                />
                <p className="legend">{image.caption}</p>
              </div>
            </Col>
          ))}
        </div>
      </Container>
    </Section>
  );
};

export { ImageGallery };
